import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {inject, observer} from "mobx-react";
import {Helmet} from 'react-helmet';
import {
  BRANDS,
  browser,
  defineCountryTextCode,
  defineIsDirRTL,
  defineIsLangCyrillic,
  defineSupportCommunicationMeans,
  getLang,
  getSignupUrl,
  htmlLangAttributes,
  IS_SERVER,
  RequireCSS
} from '../../../common';
import '../../../assets/fonts/Rubik/stylesheet.css';
import '../../../assets/fonts/Montserrat/stylesheet.css';
import '../../../assets/fonts/Roboto/stylesheet.css';
import Header from '../../templateElements/header';
import Footer from '../../templateElements/footer';
import Modal from '../../templateElements/modal';
import SocialLinks from '../../templateElements/socialLinks';
import RulesText from "./-RulesText";
import {brandContext} from "../../../store/brandContext";
import {getCookie, throwParamsToSite} from "../../../helpers";
import {useLogForClickRules} from "../../../helpers/customHooks";

const HappyHockey = inject('appStore', 'kafkaStore')(observer(({
  appStore: {
   CountryDataList,
   getCountryDataByName,
   // isUserLoggedIn,
   langIdFromMainSite
  },
  kafkaStore: {
   imprintHash
  },
  location,
  landingName,
  lang,
  promo,
}) => {
  const brandName = useContext(brandContext);
  const langAttr = htmlLangAttributes[lang];
  const [countryData, setCountryData] = useState(null);
  const [countryDataLangId, setCountryDataLangId] = useState(0);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);
  const [isDirRTL, setIsDirRTL] = useState(false);
  const [isLangCyrillic, setIsLangCyrillic] = useState(false);
  const [signupUrl, setSignupUrl] = useState('');
  const [supportCommunicationMeans, setSupportCommunicationMeans] = useState('');
  const [rulesClick, setRulesClick] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [size, setSize] = useState([0, 0]);

  const userLoggedInCookie = getCookie("user_logged_in");

  const landingNameForUtils = landingName === 'happysport' ? 'happy_hockey' : landingName

  const bgImg = require(`./img/${brandName}/bg-${landingNameForUtils}${browser().mobile ? '-mobile' : ''}.jpg`);

  const { translation } = require(`../../../translations/${landingName}/translation`);

  if (RequireCSS(location.pathname)) require('./scss/style.scss');

  const landingOptions = {
    happy_hockey: {
      contentBtnLink: `/line/popular/l_895${brandName === BRANDS.cupis && !browser().mobile && !isUserLoggedIn ? '/?login' : ''}`,
    },
    happysport: {
      contentBtnLink: `/line${brandName === BRANDS.cupis && !browser().mobile && !isUserLoggedIn ? '/?login' : ''}`,
    },
  }

  const imgCoupon = require(`./img/${brandName}/coupon-${lang}.png`);

  const defineSocialLinks = (brandName) => {
    if (brandName === BRANDS.zenbet) {
      return ['instagram', 'telegram', 'facebook'];
    } if (brandName === BRANDS.cupis) {
      return ['vk'];
    } else {
      return ['instagram', 'telegram', 'vk'];
    }
  }

  const handleModal = () => {
    setIsModalVisible(!isModalVisible);
  }

  const onRulesClick = () => {
    setRulesClick(rulesClick + 1);
    handleModal();
  }

  !IS_SERVER && useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useEffect(() => {
    setSupportCommunicationMeans(defineSupportCommunicationMeans(brandName));
    setSocialLinks(defineSocialLinks(brandName));
    setIsLangCyrillic(defineIsLangCyrillic(lang));
    setIsDirRTL(defineIsDirRTL(lang));
    setSignupUrl(getSignupUrl(brandName, lang));
  }, []);

  useEffect(() => {
    !IS_SERVER && setIsUserLoggedIn(userLoggedInCookie === '1');
  }, []);

  useEffect(() => {
    signupUrl && throwParamsToSite(
      promo && promo?.promo_code !== 'bonus15k' ? promo.promo_code : undefined,
      null,
      null,
      false,
      false,
      '.content__btn',
      brandName === BRANDS.cupis);
  }, [signupUrl]);

  useLogForClickRules(rulesClick, imprintHash);

  useEffect(() => {
    setCountryData(getCountryDataByName(defineCountryTextCode(lang)));
  }, [CountryDataList]);

  useEffect(() => {
    if (countryData) {
      if (lang === 'en') {
        setCountryDataLangId(2);
      } else {
        setCountryDataLangId(countryData.lang_id)
      }
    }
  }, [countryData]);

  useEffect(() => {
    if (countryData && countryDataLangId) {
      throwParamsToSite(
        undefined,
        countryData.id,
        langIdFromMainSite || countryDataLangId,
        false,
        !browser().mobile && !isUserLoggedIn,
        'a[href*="/line"]');
      throwParamsToSite(
        undefined,
        countryData.id,
        langIdFromMainSite || countryDataLangId,
        false,
        false,
        '.site-logo');
    }
  }, [countryData, countryDataLangId]);

  return (
    <>
      <Helmet>
        <html lang={langAttr} dir={isDirRTL ? "rtl" : "ltr"} />
        <title>{getLang(translation, brandName, lang, 'siteTitle')}</title>
      </Helmet>
      <div className={`body-wrapper body-wrapper-${lang} landing_${landingName}`}>
        <img
          src={bgImg}
          alt="bg"
          className='bg-happy-hockey'
        />

        <Header
          layout
          positionLogo="left"
          id={`header-${brandName}`}
        >
          <button className={`header-wrapper__rules-btn header-wrapper__rules-btn_${brandName}`} onClick={onRulesClick}>
            {getLang(translation, brandName, lang, 'rulesBtnText')}
          </button>
        </Header>

        <main className={`main main_${brandName} main_${landingName}`}>
          <div className="main-wrapper layout">
            <div className="main-wrapper__content">
              <div className={`content__title content__title_${brandName} content__title_${landingName}`}>
                {landingName === 'happysport' &&
                  <div className={`coupon coupon_${lang} coupon_${brandName} wow animate__animated animate__fadeInLeftBig`}>
                    <img className='coupon__img' src={imgCoupon} alt='' />
                    <p className='coupon__text'>{getLang(translation, brandName, lang, 'specialCondition')}</p>
                    <span className='coupon__text-span'>*</span>
                  </div>
                }
                <div className="wow animate__animated animate__fadeInLeftBig">
                  {brandName === BRANDS.zenbet && !isLangCyrillic &&
                    <p className={`content__subtitle content__subtitle_${lang} content__subtitle_extra`}>
                      {getLang(translation, brandName, lang, 'titleLineExtra')}
                    </p>
                  }
                  <p className={`content__subtitle content__subtitle_${lang} content__subtitle_1 content__subtitle_1_${lang}`}>
                    {getLang(translation, brandName, lang, 'titleLine1')}
                  </p>
                  <p className={`content__subtitle content__subtitle_${lang} content__subtitle_2 content__subtitle_2_${lang}`}>
                    {getLang(translation, brandName, lang, 'titleLine2')}
                  </p>
                  <p className={`content__subtitle content__subtitle_${lang} content__subtitle_3 content__subtitle_3_${lang}`}>
                    {getLang(translation, brandName, lang, 'titleLine3')}
                  </p>
                  {lang !== 'en' && <p className={`content__subtitle content__subtitle_4 content__subtitle_4_${lang}`}>
                    {getLang(translation, brandName, lang, 'titleLine4')}
                  </p>}
                </div>
                {lang === 'en' && <p className={`content__subtitle content__subtitle_4 content__subtitle_4_${lang} wow animate__animated animate__fadeInRightBig`}>
                  {getLang(translation, brandName, lang, 'titleLine4')}
                </p>}
                <p className={`content__subtitle content__subtitle_${lang} content__subtitle_5 content__subtitle_5_${lang} wow animate__animated animate__fadeInRightBig`}>
                  {getLang(translation, brandName, lang, 'titleLine5')}
                </p>
              </div>

              {!browser().mobile &&
                <a href={landingOptions[landingName].contentBtnLink} className={`content__btn content__btn_${brandName} content__btn_${landingName}`}>
                  {getLang(translation, brandName, lang, 'btnGet')}
                </a>
              }
              {!browser().mobile && <SocialLinks links={socialLinks} lang={lang} />}
            </div>
            <div className={`main-wrapper__steps main-wrapper__steps_${brandName} main-wrapper__steps_${lang} main-wrapper__steps_${landingName}`}>
              <div className="main-wrapper__step main-wrapper__step_1">
                <div className="steps__img steps__img_1"/>
                <div className="steps__text">
                  <span>{getLang(translation, brandName, lang, 'conditionSpan1')} </span>
                  <span className="span span_normal">{getLang(translation, brandName, lang, 'conditionSpan1Extra')} </span>
                  <br/>
                  {!isLangCyrillic &&
                    <>
                      <span className="span span_normal">{getLang(translation, brandName, lang, 'conditionSpan1Extra')} </span>
                      <span className="span span_normal">{getLang(translation, brandName, lang, 'conditionSpan1Part2')} </span>
                      <br/>
                    </>
                  }
                  {getLang(translation, brandName, lang, 'conditionText1')}
                </div>
              </div>
              <div className="main-wrapper__step">
                <div className="steps__img steps__img_2"/>
                <div className="steps__text steps__text_bet">
                  <span>{getLang(translation, brandName, lang, 'conditionSpan2')} </span>
                  {!isLangCyrillic && <br/>}
                  {brandName !== BRANDS.cupis && !isLangCyrillic &&
                  <span className="span span_normal">{getLang(translation, brandName, lang, 'conditionText2Extra')} </span>
                  }
                  {getLang(translation, brandName, lang, 'conditionText2')}
                  <br/>
                </div>
              </div>
              <div className="main-wrapper__step">
                <div className="steps__img steps__img_3"/>
                <div className="steps__text">
                  {!isLangCyrillic &&
                  <span>{getLang(translation, brandName, lang, 'conditionExtra3')} </span>
                  }
                  <span className={!isLangCyrillic ? 'span span_normal' : ''}> {getLang(translation, brandName, lang, 'conditionSpan3')} </span>
                  {!isLangCyrillic && <br/>}
                  {getLang(translation, brandName, lang, 'conditionText3')}
                </div>
              </div>
            </div>
            {browser().mobile &&
            <a href={`${landingName === 'happy_hockey' ? `/m` : ''}${brandName === BRANDS.zenbet ? `/${lang}` : ''}${landingOptions[landingName].contentBtnLink}`}
               className={`content__btn content__btn_${brandName} content__btn_${landingName}`}>
              {getLang(translation, brandName, lang, 'btnGet')}
            </a>
            }
          </div>
        </main>
        {browser().mobile && <SocialLinks links={socialLinks} />}
        <Footer
          id={`footer-${brandName}`}
          className={`footer-${landingName}`}
          layout
          hasCopyright
          bkString={getLang(translation, brandName, lang, 'bkString')}
          rightString={getLang(translation, brandName, lang, 'rightString')}
          hasPayments={false}
          lang={lang}
        >
          <div>
            {landingName === 'happysport' &&
              <p className="footer-wrapper__footnote">{getLang(translation, brandName, lang, 'footnoteText')}</p>
            }
              <div className="footer-wrapper__support">
              {getLang(translation, brandName, lang, 'supportText')} <a
              dir="ltr" href={supportCommunicationMeans}><span className="span">{getLang(translation, brandName, lang, 'supportSpan')}</span></a>
            </div>
          </div>
        </Footer>

        <Modal
          onClose={handleModal}
          visible={isModalVisible}
          title={getLang(translation, brandName, lang, 'rulesHeaderText')}
        >
          <div id="modal-rules">
            <RulesText
              brandName={brandName}
              lang={lang}
              landingName={landingName}
            />
          </div>
        </Modal>

      </div>
    </>
  );
}));

export default HappyHockey;
